/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-handler-names */
import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import isEmpty from "lodash/isEmpty";
import LineItemModal from "../LineItemModal";
import Icon from "wonderbly-components/lib/Icon";

import "./LineItemImage.scss";

const LineItemImageCta = (props) => {
  return props.withoutLineItemModal ? (
    <div className="LineItemImage__cta">{props.children}</div>
  ) : (
    <button
      className="LineItemImage__cta"
      onClick={() => props.setShowModal(true)}
    >
      {props.children}
      <span className="LineItemImage__zoom">
        <Icon icon="zoomin" />
      </span>
    </button>
  );
};

const LineItemImage = (props) => {
  if (isEmpty(props.image)) {
    return null;
  }

  const [showModal, setShowModal] = useState(false);

  return (
    <div
      className={cx("LineItemImage__wrapper", {
        "LineItemImage__wrapper--has-addon": !isEmpty(props.addons),
      })}
    >
      <LineItemImageCta {...props} setShowModal={setShowModal}>
        {props.addons.map((addon) => (
          <img
            key={`addon-image-${addon.id}`}
            src={addon.image.url}
            alt={addon.image.alt || ""}
            className="LineItemImage__image LineItemImage__image--addon"
          />
        ))}
        <img
          src={`${props.image.url}${
            props.image.isMuseImage ? "&_width=958" : ""
          }`}
          alt={props.image.alt || props.title}
          className={cx(
            "LineItemImage__image",
            { "LineItemImage__image--muse": props.image.isMuseImage },
            { "LineItemImage__image--default": !props.image.isMuseImage }
          )}
        />
      </LineItemImageCta>
      {!props.withoutLineItemModal && (
        <LineItemModal
          isOpen={showModal}
          image={props.image}
          title={props.title}
          edit={props.edit}
          backgroundColor={props.backgroundColor}
          handleClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

LineItemImageCta.propTypes = {
  withoutLineItemModal: PropTypes.bool,
  children: PropTypes.node.isRequired,
  setShowModal: PropTypes.func,
};

LineItemImage.defaultProps = {
  addons: [],
};

LineItemImage.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    isMuseImage: PropTypes.bool,
  }),
  edit: PropTypes.shape({
    editUrl: PropTypes.object,
    handleEdit: PropTypes.func,
    isEditable: PropTypes.bool,
  }),
  title: PropTypes.string,
  addons: PropTypes.array,
  backgroundColor: PropTypes.string,
  withoutLineItemModal: PropTypes.bool,
};

export default LineItemImage;
